<template>
  <div style="margin-bottom: 10px">
    <el-cascader
      :options="availableAttachments"
      v-model="valuesOfNodes"
      clearable
      filterable
      placeholder="请选择物品（可搜索）"
      :props="{ expandTrigger: 'hover' }"
      style="width:300px"
    ></el-cascader>
    <span>&nbsp;x&nbsp;</span
    ><el-input v-model="attachmentNumber" class="number-input"></el-input>
    <el-button
      @click="onClickRemoveBtn()"
      style="margin-left: 10px"
      icon="el-icon-delete"
      circle
    ></el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      valuesOfNodes: this.value.valuesOfNodes,
      attachmentNumber: this.value.number,
    };
  },

  props: {
    availableAttachments: Array,
    value: Object,
  },

  watch: {
    valuesOfNodes() {
      this.$emit("input", this.formattedAttachment);
    },

    /**
     * 修正数目输入框里的值
     */
    attachmentNumber() {
      let attachmentNumber = parseInt(this.attachmentNumber);
      if (isNaN(attachmentNumber)) {
        attachmentNumber = 1;
      }
      this.attachmentNumber = attachmentNumber;

      this.$emit("input", this.formattedAttachment);
    },
  },

  computed: {
    /**
     * 用来返回给外部的
     */
    formattedAttachment() {
      return {
        valuesOfNodes: this.valuesOfNodes,
        number: this.attachmentNumber,
      };
    },
  },

  methods: {
    onClickRemoveBtn() {
      // 向父组件抛出事件
      this.$emit("remove");
    },
  },
};
</script>

<style lang="scss" scoped>
.number-input {
  width: 120px;
}
</style>